import { SsoEmailDomainModel } from "./SsoEmailDomain.model";

export class SsoEmailDomain extends SsoEmailDomainModel {
    // Add custom methods here
}
